export const OF_COLORS = [
  '#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#06b6d4',
  '#ef4444', '#8d6e63', '#d4e157', '#6366f1', '#ec4899'
]

/**
 * Generates a deterministic color based on an ID.
 * @param {string|number} id - The ID to generate a color for.
 * @returns {string} The hex color code.
 */
export const colorForOf = (id) => {
  if (!id && id !== 0) return OF_COLORS[0]
  const idx = Math.abs(
    (typeof id === 'number' ? id : String(id).split('').reduce((a, c) => a + c.charCodeAt(0), 0))
  ) % OF_COLORS.length
  return OF_COLORS[idx]
}
